import React from "react";
import classNames from "classnames";

import Icon, { IconType } from "../Icon/Icon";
import styles from "./IconButton.module.scss";

interface Props {
  dataQA: string;
  icon: IconType;
  size?: "small" | "medium" | "large";
  largeIcon?: boolean;
  disabled?: boolean;
  theme?: "light" | "dark";
  className?: string;
  onClick: () => void;
}

const IconButton: React.FC<Props> = ({
  dataQA,
  icon,
  size = "medium",
  largeIcon,
  disabled,
  theme = "light",
  className,
  onClick,
}) => {
  const iconSize = largeIcon ? 20 : 15;

  return (
    <button
      data-qa={dataQA}
      className={classNames(
        styles.container,
        styles[theme],
        styles[size],
        className,
        {
          [styles.disabled]: disabled,
        },
      )}
      disabled={disabled}
      onClick={onClick}
    >
      <Icon dataQA="icon" type={icon} width={iconSize} height={iconSize} />
    </button>
  );
};

export default IconButton;
